import { List,Record } from "immutable";

import timelineLayoutOptions from "../../../../constants/timelineLayoutOptions";
import { TimelineZoomLimits } from "../../../../constants/zoomRange";
import createFromJS from "../../../createFromJS";

export const TimelineViewSettingsRecord = Record({
  // TODO: Change scroll/layout to fixed enum values
  scrollBounds: "infinite",
  eventLayout: timelineLayoutOptions.CLEAR_ALL,
  showItemCard: true,
  showIdentifier: false,
  showDates: true,
  showDuration: false,
  showNarrative: false,
  showRelationshipTypes: List(),
  showBlocks: false,
  showBlockedBy: false,
  showImage: false,
  showSummary: false,
  showInfoIcons: false,
  showDependencies: true,
  showTodayLine: false,
  zoomFrom: TimelineZoomLimits.Decade,
  zoomTo: TimelineZoomLimits.Day,
  showTypes: List([])
});

const data = {
  objects: {
    showTypes: "List",
    showRelationshipTypes: "List"
  }
};
createFromJS.registerCallback(
  "TimelineViewSettingsRecord",
  createFromJS.createNestedCallback(TimelineViewSettingsRecord, data)
);
